import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import ArticleHero from './components/ArticleHero';
import ArticleContent from './components/ArticleContent';
import ArticleComments from './components/ArticleComments';
import RelatedArticles from './components/RelatedArticles';
import { mockArticles } from '@/mocks/articles';
import { buildArticleSchema, buildBreadcrumbSchema } from '@/mocks/schema';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const fallbackArticle = mockArticles[0];
  const article = mockArticles.find((a) => a.slug === slug) || fallbackArticle;

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="w-full px-4 md:px-8 pt-28 pb-14 text-center">
          <h1 className="text-2xl font-heading text-foreground-950">文章未找到</h1>
          <Link to="/" className="inline-block mt-4 text-sm text-primary-500 hover:underline cursor-pointer">
            返回首页
          </Link>
        </main>
        <Footer />
      </>
    );
  }

  const articleSchema = buildArticleSchema({
    title: article.title,
    description: article.excerpt,
    imageUrl: article.imageUrl,
    datePublished: article.date,
    dateModified: article.date,
    url: `http://dingzhishi.cn/article/${article.slug}`,
  });

  const breadcrumbSchema = buildBreadcrumbSchema([
    { name: '首页', url: 'http://dingzhishi.cn/' },
    { name: article.categoryName, url: `http://dingzhishi.cn/category/${article.category}` },
    { name: article.title, url: `http://dingzhishi.cn/article/${article.slug}` },
  ]);

  return (
    <>
      <SchemaOrg data={articleSchema} />
      <SchemaOrg data={breadcrumbSchema} />
      <Navbar />
      <main>
        <nav className="w-full px-4 md:px-8 pt-20" aria-label="Breadcrumb">
          <div className="max-w-[1280px] mx-auto flex items-center gap-2 text-xs text-foreground-500">
            <Link to="/" className="hover:text-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </span>
            <Link
              to={`/category/${article.category}`}
              className="hover:text-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              {article.categoryName}
            </Link>
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </span>
            <span className="text-foreground-700 whitespace-nowrap line-clamp-1">{article.title}</span>
          </div>
        </nav>
        <ArticleHero article={article} />
        <ArticleContent article={article} />
        <ArticleComments article={article} />
        <RelatedArticles currentSlug={article.slug} />
      </main>
      <Footer />
    </>
  );
}